import LandingPage from "./landingpage/LandingPage";
import Services from "./servicespage/Services";
import WhatWeDo from "./whatwedo/WhatWeDo";

const HomePage = () => {
 return (
  <>
   <LandingPage />
   <WhatWeDo />
   <Services />
  </>
 );
};

export default HomePage;
